import Component from './business-info-form';
export default Component;
